module.exports = __webpack_public_path__ + "static/media/undraw_Designer_by46.b4d0daa5.svg";